import { Helmet } from "react-helmet";
import leftSide from "../Assets/Data/Car";
import claimLeftSide from "../Assets/Data/SplitCar";
import Fullscreen from "../Assets/Images/fullscreen.svg";
import ExitScreen from "../Assets/Images/exit-screen.svg";
import Camera from "../Assets/Images/camera.svg";
import Lightmode from "../Assets/Images/light-mode.svg";
import DarkMode from "../Assets/Images/dark-mode.svg";
import Close from "../Assets/Images/Close.svg";
import Tick from "../Assets/Images/vector.svg";
import CarF from "../Assets/Images/carF.svg";
import CarT from "../Assets/Images/carT.svg";
import Uploading from "../Assets/Images/uploading.svg";
import Logo from "../Assets/Images/logo_hdfc.svg";
import uploadFinished from "../Assets/Images/uploadFinished.svg";
import uploadArrow from "../Assets/Images/uploadArrow.svg";

const ImagePreloadHead = () => {
  const imageSet = new Set();

  leftSide.forEach((item) => {
    imageSet.add(item.stencil);
    if (item.greenStencil) imageSet.add(item.greenStencil);
    if (item.redStencil) imageSet.add(item.redStencil);
    if (item.ImageSrc) imageSet.add(item.ImageSrc);
  });

  claimLeftSide.forEach((item) => {
    imageSet.add(item.stencil);
    if (item.greenStencil) imageSet.add(item.greenStencil);
    if (item.redStencil) imageSet.add(item.redStencil);
    if (item.ImageSrc) imageSet.add(item.ImageSrc);
  });

  const addImages = [
    Fullscreen,
    ExitScreen,
    Camera,
    Lightmode,
    DarkMode,
    Close,
    Tick,
    CarF,
    CarT,
    Logo,
    Uploading,
    uploadFinished,
    uploadArrow,
  ];
  addImages.forEach((item) => {
    imageSet.add(item);
  });

  return (
    <Helmet>
      {[...imageSet].map((src, idx) => (
        <link key={idx} rel="preload" as="image" href={src} />
      ))}
    </Helmet>
  );
};

export default ImagePreloadHead;
